<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-router-link
                v-for="charge in charges"
                :key="charge.uuid"
                :to="{
                    name: $router.fix('dashboard.*.charges.show'),
                    params: {
                        charge: charge.uuid
                    }
                }"
            >
                <table-ish-cell
                    :shrink="true"
                    class="pr-0"
                >
                    <base-svg
                        :class="{
                            'fill-primary-grey-dark fill-secondary-grey-light': charge.state === 'requested' || charge.state === 'pending',
                            'fill-primary-green-dark fill-secondary-green-light': charge.state === 'succeeded',
                            'fill-primary-red-dark fill-secondary-red-light': charge.state === 'failed',
                            'fill-primary-yellow-dark fill-secondary-yellow-light': charge.state === 'unconfirmed',
                        }"
                        :name="charge.state === 'succeeded'
                            ? 'icon-check-circle'
                            : (charge.state === 'failed'
                                ? 'icon-close-circle'
                                : (charge.state === 'unconfirmed'
                                    ? 'icon-important-circle'
                                    : 'icon-asterisk-circle'
                                )
                            )"
                        class="w-6 h-6"
                    />
                </table-ish-cell>
                <table-ish-cell>
                    <truncate-hack>
                        {{ charge.properties.data | comma-delimited({
                            callback: property => property.address.name
                        }) }}
                    </truncate-hack>

                    <truncate-hack slot="secondary">
                        <span
                            v-if="charge.state === 'requested'"
                            :class="width > 500 ? 'text-sm py-1' : 'text-xs'"
                            class="px-2 mr-2 font-semibold leading-none rounded-full bg-grey-lighter text-grey-darker"
                        >
                            Requested
                        </span>

                        <span
                            v-if="charge.state === 'unconfirmed'"
                            :class="width > 500 ? 'text-sm py-1' : 'text-xs'"
                            class="px-2 mr-2 font-semibold leading-none rounded-full bg-grey-lighter text-grey-darker"
                        >
                            Action Required
                        </span>

                        {{ charge.rents.data | comma-delimited({
                            callback: rent => $moment(rent.due_at).format('MMM [Rent]'),
                            total: charge.rents.meta.total
                        }) }}

                        <template v-if="charge.rents.meta.total > 0 && charge.fees.meta.total > 0">
                            &amp;
                        </template>

                        {{ charge.fees.data | comma-delimited({
                            callback: fee => fee.title,
                            total: charge.fees.meta.total
                        }) }}
                    </truncate-hack>
                </table-ish-cell>

                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    <span
                        :class="{
                            'bg-grey-lighter text-grey-darker': charge.is_offline,
                            'bg-blue-lighter text-blue-darker': charge.was_scheduled,
                            'bg-green-lighter text-green-darker': !charge.is_offline && !charge.was_scheduled
                        }"
                        class="px-3 py-1 text-sm font-semibold rounded-full"
                    >
                        <template v-if="charge.is_offline">Offline</template>
                        <template v-else-if="charge.was_scheduled">Smart Payment</template>
                        <template v-else>Card</template>
                    </span>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    <span
                        :class="{
                            'line-through': charge.state === 'failed',
                            'text-grey-dark': charge.state === 'failed' || charge.state === 'unconfirmed'
                        }"
                    >
                        {{ charge.amount | money }}
                    </span>

                    <template
                        v-if="width < 500"
                        slot="secondary"
                    >
                        <span
                            :class="{
                                'bg-grey-lighter text-grey-darker': charge.is_offline,
                                'bg-blue-lighter text-blue-darker': charge.was_scheduled,
                                'bg-green-lighter text-green-darker': !charge.is_offline && !charge.was_scheduled
                            }"
                            class="px-2 text-xs font-semibold leading-none rounded-full"
                        >
                            <template v-if="charge.is_offline">Offline</template>
                            <template v-else-if="charge.was_scheduled">Smart Payment</template>
                            <template v-else>Card</template>
                        </span>
                    </template>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    export default {
        props: {
            charges: {
                type: Array,
                required: true
            }
        }
    }
</script>
